import { createApp } from 'vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/style/common.scss'
import '@/assets/style/config.scss'
import router from './router'
import App from './App.vue'
import store from './store'
import * as elIcons from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn'

document.title = store.state.app.systemTitle

const app = createApp(App)
for (let icon in elIcons) {
    app.component(`ElIcon${icon}`, elIcons[icon])
}
app.use(store);
app.use(router);
app.use(ElementPlus, {size: "default", locale: zhCn});
app.mount('#app')